export default __webpack_public_path__ + "static/media/icon_arrow_down_white.7978af54.svg";